var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Обратная связь - горячая линия")]),_c('table',[_vm._m(0),_c('tr',[_c('td',{domProps:{"innerHTML":_vm._s(_vm.getFeedbackHotline.feedback)}}),_c('td',{staticClass:"drop-icon"},[_c('router-link',{attrs:{"to":"/admin/feedback_hotline/create"}},[_vm._v("Редактировать")])],1)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v("Информация")]),_c('td',{staticClass:"drop-icon"})])
}]

export { render, staticRenderFns }